import React, { useState } from 'react';
import { auth, db } from '../firebase/firebaseConfig'; // Stellen Sie sicher, dass db (firestore) exportiert ist
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore'; 


const Registrierung = (onSwitch) => {
  const [showPassword, setShowPassword] = useState(false);
  // States für die Eingabefelder
  const [formData, setFormData] = useState({
    anrede: '',
    email: '',
    vorname: '',
    nachname: '',
    passwort: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      // 1. Benutzer in Firebase Authentication erstellen
      const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.passwort);
      
      // 2. Zusätzliche Infos (Vorname/Nachname) in Firestore speichern
      await setDoc(doc(db, "users", userCredential.user.uid), {
        anrede: formData.anrede,
        vorname: formData.vorname,
        nachname: formData.nachname,
        email: formData.email
      });

      alert("Registrierung erfolgreich!");
    } catch (error) {
      console.error("Fehler bei der Registrierung:", error);
      alert("Fehler: " + error.message);
    }
  };

  return (
    <div className="atelier-registration" style={{ padding: '40px', maxWidth: '450px', margin: 'auto' }}>
      <h2 style={{ fontFamily: 'serif', textAlign: 'center', color: '#333' }}>Konto erstellen</h2>
      
      <form onSubmit={handleRegister}>
        {/* Anrede */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '10px', fontSize: '0.8rem' }}>Anrede</label>
          <input type="radio" id="frau" name="anrede" value="Frau" onChange={handleChange} /> <label htmlFor="frau" style={{ marginRight: '20px' }}>Frau</label>
          <input type="radio" id="herr" name="anrede" value="Herr" onChange={handleChange} /> <label htmlFor="herr">Herr</label>
        </div>

        {/* E-Mail */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontSize: '0.8rem' }}>E-Mail-Adresse</label>
          <input type="email" name="email" onChange={handleChange} style={{ width: '100%', border: 'none', borderBottom: '1px solid #d4af37', padding: '8px 0' }} required />
        </div>

        {/* Name & Vorname */}
        <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontSize: '0.8rem' }}>Vorname</label>
            <input type="text" name="vorname" onChange={handleChange} style={{ width: '100%', border: 'none', borderBottom: '1px solid #d4af37', padding: '8px 0' }} required />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontSize: '0.8rem' }}>Nachname</label>
            <input type="text" name="nachname" onChange={handleChange} style={{ width: '100%', border: 'none', borderBottom: '1px solid #d4af37', padding: '8px 0' }} required />
          </div>
        </div>

        {/* Passwort */}
        <div style={{ marginBottom: '30px', position: 'relative' }}>
          <label style={{ display: 'block', fontSize: '0.8rem' }}>Passwort</label>
          <input 
            type={showPassword ? "text" : "password"} 
            name="passwort"
            onChange={handleChange}
            style={{ width: '100%', border: 'none', borderBottom: '1px solid #d4af37', padding: '8px 0' }} 
            required
          />
          <span onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '0', bottom: '8px', cursor: 'pointer', fontSize: '0.8rem' }}>
            {showPassword ? "Verbergen" : "Anzeigen"}
          </span>
        </div>

        <button type="submit" style={{ width: '100%', padding: '15px', backgroundColor: '#333', color: '#fff', border: 'none', marginTop: '20px', cursor: 'pointer' }}>
          WEITER
        </button>
      </form>
      <p style={{ textAlign: 'center', marginTop: '20px' }}>
  Bereits ein Konto?
</p>

<button
  type="button"
  onClick={onSwitch}
>
  Zur Anmeldung
</button>
    </div>
  );
};
export default Registrierung;